import * as React from "react";
import { GlyphIcon } from "../icons";
import { ButtonProps, Glyphicon } from "react-bootstrap";
import { BasicButton } from "./BasicButton";
import { ButtonColor } from "./types";
import classNames from "classnames";

export interface GlyphButtonProps extends ButtonProps {
    glyph?: GlyphIcon;
    color?: ButtonColor;
    bsClass?: string;
    className?: string;
}

export const GlyphButton = (props: GlyphButtonProps) => {
    const { glyph, color = ButtonColor.PRIMARY, className: classnameProps, ...rest } = props;
    const className = classNames(classnameProps, "square-button");
    return (
        <BasicButton color={color} className={className} {...rest}>
            {glyph ? <Glyphicon glyph={glyph} /> : <Glyphicon glyph={GlyphIcon.ALERT} color={ButtonColor.DANGER} />}
        </BasicButton>
    );
};
